import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

import { childrenBookPrintingImg2 } from "../../asserts/images";

const ChildrenBookPrinting = () => {
  return (
    <>

    <Helmet>
        <meta charSet="utf-8" />
        <title>
            Hire #1 Children's Book Printing Services | Falcon Book Writing
        </title>
        <meta
          name="description"
          content="Hire #1 Children’s Book Printing Services from Falcon Book Writing for high-quality, vibrant printing that brings your story to life with professional finishes."
        />
        <meta name="keywords" content="Children’s Book Printing" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


      <UserLayout>
        <InnerHero
          innerheroclass="childrenBookPrintingBg"
          title="Custom "
          subtitle=" Children’s Book Printing "
          title2="With Stunning Visual Quality "
          para="Bring your children’s stories to life with custom book printing that showcases vibrant colors, crisp illustrations, and professional layouts. Every page is crafted to delight young readers, creating visually stunning books they’ll treasure forever. "
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section"
          title="Every Page Perfectly "
          subtitle=" Printed "
          title2="for Young Readers"
          // subtitle1="How we work?"
          description="Children’s books deserve more than words, they deserve vibrant, high-quality printing that brings every story to life. Our children’s book printing service ensures each page is perfectly produced, highlighting illustrations, colors, and layouts to capture young readers’ attention. Every detail, from typography to image clarity, is meticulously crafted to provide a seamless reading experience that engages and delights. We work across genres and age groups, making sure each book resonates visually while maintaining durability and professional quality. Whether it’s a picture book, early reader, or chapter book, our printing transforms your manuscript into a tangible work of art that kids will love to explore. With precise color reproduction, sharp illustrations, and flawless layouts, every page becomes a captivating adventure, turning your story into a treasured keepsake."
          // subtitle2="    Tailored Collaborations?"
          // subtitle3="  Expert Guidance"
          image={childrenBookPrintingImg2}
          imgClass="childrenBookPrintingImg2"
          actions={true}
          btn1="Let’s Get Start"
          btn2="Call Us Now"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default ChildrenBookPrinting;
